import orm from '@/launcher/store/plugins/orm';
import subscriptions from '@/launcher/store/plugins/subscriptions';
import timer from '@/launcher/store/plugins/timer/plugin';
import createPersistedState from 'vuex-persistedstate';

export default [
  orm,
  subscriptions,
  timer,
  createPersistedState({
    paths: ['orm', 'launcher'],
    getState (key, storage, value) {
      try {
        const stored =
          (value = storage.getItem(key)) && typeof value !== 'undefined'
            ? JSON.parse(value)
            : undefined;
        const { orm, launcher } = stored || {};
        launcher && delete launcher.previousSession; // prevent sessionId to be persisted (might cause CL tracking issues otherwise)
        return {
          orm: orm || {}, // we always hydrate with entities cause it is just a local database
          storedLauncherState: launcher, // this allow to retrieve last known state when fully offline
        };
      } catch (err) {}

      return undefined;
    },
  }),
];
